
import { cloneDeep } from "lodash-es";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import draggable from "vuedraggable";

@Component({
  components: {
    draggable
  }
})
export default class RuleItem extends Vue {
  @Prop({ default: "" }) title!: string;
  @Prop({ default: () => [] }) ruleList!: any[];
  @Prop({ type: String }) group!: string;
  @Prop({ type: String }) icon!: string;
  @Prop({ type: String }) color!: string;
  @Prop({ type: String }) bgColor!: string;
  @Prop({ type: String }) bdColor!: string;
  @Prop({ type: Boolean }) showContent!: boolean;
  @Prop({ type: Boolean, default: true }) showTitle!: boolean;

  list = [];

  changeRuleList() {
    this.$emit("update", this.list);
  }

  @Watch("ruleList", { immediate: true })
  changeList(value: any) {
    this.list = cloneDeep(value);
  }
}
